<template>
  <div class="paginator" v-show="pageLoading">
    <!-- <div @click="pageUp" :style="pageUpStyle">
      上一页
    </div>
    <div class="line">
      ｜
    </div>
    <div @click="pageDown" :style="pageDownStyle">
      下一页
    </div> -->
    <img :src="imageMap.spinner" alt="" class="spinner">
    <div class="text">
      正在查询
    </div>
  </div>
</template>

<script>
  import imageMap from '../../image-map.js';

  import { mapMutations, mapState, mapGetters } from 'vuex';

  export default {
    data() {
      return { imageMap };
    },

    computed : {
      ...mapState( 'virusTrip', [ 'pageNumber', 'pageCount', 'pageLoading' ] ),

      ...mapGetters( 'virusTrip', [ 'virusTripList' ] ),

      isFirstPage() {
        return this.pageNumber === 0;
      },

      isLastPage() {
        return (
          this.pageNumber === Math.floor(
            this.virusTripList.length / this.pageCount
          )
        );
      },

      pageUpStyle() {
        return this.isFirstPage ? {
          color : '#a8a8a8'
        } : {
          color : '#0077ff'
        };
      },

      pageDownStyle() {
        return this.isLastPage ? {
          color : '#a8a8a8'
        } : {
          color : '#0077ff'
        }
      }
    },

    methods : {
      ...mapMutations( 'virusTrip', [
        'updatePageNumber', 'updatePageLoading'
      ] ),

      scrollTop() {
        window.scrollTo( 0, 0 );
      },

      pageUp() {
        if ( !this.isFirstPage ) {
          this.updatePageNumber( this.pageNumber - 1 );
          this.scrollTop();
        }
      },

      pageDown() {
        if ( !this.isLastPage ) {
          this.updatePageNumber( this.pageNumber + 1 );
          this.scrollTop();
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "./paginator.scss";
</style>



// WEBPACK FOOTER //
// src/projects/virusTrip/pages/searchResult/paginator.vue